<div class="box">
  <div class="header">
    <div class="content greendAnalityco">{{'ENVIO DE INFORME' || 'N/A'}}</div>
  </div>

  <div class="content-card-sending-reports list-sending-reports">
      <div class="sub-header-sending-reports">
        <div class="sub-content-sending greendAnalityco">{{'INFORME' || 'N/A'}}</div>
      </div>
      <div class="fields-group-sending-reports">
        <div class="access-reports-sending">
          <div class="report-card-sending">
            <div class="icon">
              <img [src]="s3Bucket+report.img" alt="icono" />
            </div>
            <div class="text">
              <div class="title">{{ report.title}}</div>
              <div class="desc">{{ report.desc}}</div>
              <div class="desc">{{ report.desc2}}</div>
              <div class="desc">{{ report.desc3}}</div>

            </div>
          </div>
        </div>
      </div>

    <ng-container *ngIf="companyUsersTrue.length > 0">
      <div class="sub-header-sending-reports">
        <div class="sub-content-sending-reports greendAnalityco">{{'USUARIO DE LA EMPRESA' || 'N/A'}}</div>
      </div>

      <div class="fields-ProfileSelect-sending">
        <div class="chip-list-wrapper">
          <mat-form-field class="chip-list" appearance="none">
            <mat-chip-list #chipListProfiles>
              <mat-chip
                *ngFor="let user of companyUsersTrue"
                [removable]="companyUsersTrue.length > 1 || selectedSearchuserVincular.length > 0"
                (removed)="onRemoveCompanyUser(user)"
              >
                {{ user.Email }}
                <mat-icon matChipRemove *ngIf="companyUsersTrue.length > 1 || selectedSearchuserVincular.length > 0">cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="sub-header-sending-reports" style="margin-top: -10px;">
        <div class="sub-content-sending-reports greendAnalityco">ADICIONAR USUARIO</div>
    </div>

      <div class="container-for-adding-users" >
        <form [formGroup]="formVincularUser">
        <div class="data-flex-sending">
          <mat-form-field class="input-field-80" style="width: 257px;" appearance="fill">
            <mat-label>INDICANOS QUE USUARIO DESEAS ADICIONAR</mat-label>
            <input matInput type="text" formControlName="Email">
            <mat-error>Requerido</mat-error>
          </mat-form-field>
          <button mat-mini-fab class="searchUser" type="button" matTooltipPosition="above" matTooltip="Buscar por correo" (click)="searchgetUserByEmail()" >
            <mat-icon>search</mat-icon>
          </button>
        </div>
        </form>
      </div>

      <div *ngIf="selectedSearchuserVincular.length > 0">
        <mat-chip-list>
          <mat-chip
            *ngFor="let user of selectedSearchuserVincular"
            class="chip-item"
            [removable]="true"
            (removed)="onRemoveAdicionarUser(user)"
          >
            {{ user.Email }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>

    <div class="actions-dialog-sending-reports" style="margin-top: 10px;">
        <button mat-flat-button  class="btn-cancel-sending" (click)="close()" type="button">CANCELAR</button>&nbsp;&nbsp;
        <button mat-flat-button  type="button" class="btn-save-sending"
                (click)="saveSendingReports()">ENVIAR</button>
      </div>
  </div>
</div>
